export const isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
};

export const isSafari = () => {
  return navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome') && !navigator.userAgent.includes('Chromium');
};

export const isTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

// check if device is mobile
export const isMobileDevice = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isTouch = isTouchDevice();

  // Check for mobile user agents
  const isMobileUA = /iphone|ipod|android|blackberry|windows phone/g.test(userAgent);

  // Check for tablets specifically
  const isTablet = /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/g.test(userAgent);

  // Check for small screens
  const maxWidth = window.matchMedia('(max-width: 768px)').matches;

  // Check if it's an Apple device (includes iPad detection)
  const isApple = isAppleDevice();

  // Return true if:
  // 1. It's a touch device AND
  // 2. Either:
  //    - It's a mobile phone (mobile UA)
  //    - It's a tablet (tablet UA or iPad)
  //    - It's a small touch screen device
  return isTouch && (isMobileUA || isTablet || isApple || maxWidth);
};

export const getKeyboardKeyLocation = (location: number): 'standard' | 'left' | 'right' | 'numpad' => {
  switch (location) {
    case 0:
      return 'standard';
    case 1:
      return 'left';
    case 2:
      return 'right';
    case 3:
      return 'numpad';
    default:
      return 'standard';
  }
};

export const getMouseButton = (button: number): 'back' | 'forward' | 'left' | 'middle' | 'right' => {
  switch (button) {
    case 0:
      return 'left';
    case 1:
      return 'middle';
    case 2:
      return 'right';
    case 3:
      return 'back';
    default:
      return 'forward';
  }
};

export const isAppleDevice = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase();

  // Check for iOS devices
  const isIOS = /iphone|ipad|ipod/.test(userAgent);

  // Check for macOS
  const isMac = /macintosh|mac os x/.test(userAgent);

  // Check for Safari browser
  const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);

  // Check for iPad that identifies as MacOS in newer versions
  const isIPadOS = isMac && navigator.maxTouchPoints > 0;

  return isIOS || isMac || isIPadOS || isSafari;
};
